// libs
import { useEffect, useState } from 'react';
import { LocalStorageUtils } from '../../utils';
import { LocalStorageProviderProps } from './provider-props.interface';

const STORAGE_PREFIX = process.env.STORAGE_PREFIX || 'pamplead';

export function LocalStorageProvider<Data>(props: LocalStorageProviderProps<Data>) {
  const { children, storageKey, context } = props;
  const [data, setData] = useState<Data | null>(null);
  const key = `${STORAGE_PREFIX}:${storageKey}`;

  useEffect(() => {
    const storedData: Data | null = LocalStorageUtils.getItem(key);

    if (storedData) setData(storedData);
  }, [key]);

  const setStoredData = (data: Data) => {
    setData(data);
    LocalStorageUtils.setItem(key, data);
  };

  return (
    <context.Provider
      value={{
        data,
        setData: setStoredData,
      }}
    >
      {children}
    </context.Provider>
  );
}

export default LocalStorageProvider;
